import React, { useState } from 'react';
import {
  Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, Label, Form, FormGroup,
} from 'reactstrap';
import LaddaButton, { EXPAND_RIGHT } from 'react-ladda';
import PropTypes from 'prop-types';

import { AccountSignatureWayOfAction } from '../Account/types';

function generateInitialSignature(id, holder, signature) {
  if (signature) return signature;
  return {
    SignatureSetId: id,
    SignatureSetPersonId: holder.AccountHolderId,
    SignatureSetPersonName: holder.AccountHolderName,
    SignatureSetWayOfAction: AccountSignatureWayOfAction.Joint,
    SignaturePeopleSelected: [],
  };
}

function generateCheckedObject(holders, signature) {
  const checkedObject = {};
  holders.forEach((h) => {
    checkedObject[h.AccountHolderId] = false;
  });
  if (signature) {
    signature.SignaturePeopleSelected.forEach((sp) => {
      checkedObject[sp.SignaturePersonId] = true;
    });
  }
  return checkedObject;
}

function signatureIsComplete(newSignature) {
  let res = true;
  Object.keys(newSignature).forEach((key) => {
    if (!newSignature[key] && (key !== 'SignatureSetId')) {
      res = false;
    }
  });
  if (newSignature.SignatureSetWayOfAction
    === AccountSignatureWayOfAction.Joint
    && newSignature.SignaturePeopleSelected.length === 0) {
    res = false;
  }
  return res;
}

const ModalSignature = ({
  signature, holders, newSetId, onSave, saving, open, toggle,
}) => {
  const [newSignature, setNewSignature] = useState(generateInitialSignature(
    newSetId,
    holders[0],
    signature,
  ));
  const [checkedHolder, setCheckedHolder] = useState(generateCheckedObject(holders, signature));
  const changeSignatureField = (name, value) => {
    if (name === 'SignaturePeopleSelected') {
      const people = newSignature.SignaturePeopleSelected;
      if (!checkedHolder[value]) {
        let personName = '';
        holders.forEach((h) => {
          if (parseInt(h.AccountHolderId, 10) === parseInt(value, 10)) {
            personName = h.AccountHolderName;
          }
        });
        people.push({
          SignaturePersonId: value,
          SignaturePersonName: personName,
        });
      } else {
        let index = -1;
        people.forEach((sp, i) => {
          if (parseInt(sp.SignaturePersonId, 10) === parseInt(value, 10)) {
            index = i;
          }
        });
        if (index > -1) people.splice(index, 1);
      }
      setCheckedHolder({
        ...checkedHolder,
        [value]: !checkedHolder[value],
      });
      setNewSignature({
        ...newSignature,
        SignaturePeopleSelected: people,
      });
    } else {
      let personName;
      if (name === 'SignatureSetPersonId') {
        holders.forEach((h) => {
          if (parseInt(h.AccountHolderId, 10) === parseInt(value, 10)) {
            personName = h.AccountHolderName;
          }
        });
      }
      setNewSignature({
        ...newSignature,
        [name]: value,
        SignatureSetPersonName: personName || newSignature.SignatureSetPersonName,
        SignaturePeopleSelected: [],
      });
      setCheckedHolder(generateCheckedObject(holders, undefined));
    }
  };

  return (
    <Modal isOpen={open} toggle={toggle}>
      <ModalHeader toggle={toggle}>{signature ? 'Edit Signature Set' : 'Create a new Signature Set'}</ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label>Person: </Label>
            <Input type="select" value={newSignature.SignatureSetPersonId} onChange={(e) => changeSignatureField('SignatureSetPersonId', e.target.value)}>
              {holders && holders.map((h, i) => (
                <option key={i} value={h.AccountHolderId}>{h.AccountHolderName}</option>
              ))}
            </Input>
          </FormGroup>
          <FormGroup>
            <Label>Account Way of Action: </Label>
            <Input type="select" value={newSignature.SignatureSetWayOfAction} onChange={(e) => changeSignatureField('SignatureSetWayOfAction', e.target.value)}>
              {Object.keys(AccountSignatureWayOfAction).map((key, i) => (
                <option key={i} value={key}>{AccountSignatureWayOfAction[key]}</option>
              ))}
            </Input>
          </FormGroup>
          {newSignature.SignatureSetWayOfAction === AccountSignatureWayOfAction.Joint
            && (
              <React.Fragment>
                <Label>Mark all the Holders to add to this Signature Set: </Label>
                {holders.map((h, i) => {
                  if (parseInt(h.AccountHolderId, 10)
                    === parseInt(newSignature.SignatureSetPersonId, 10)) return null;
                  return (
                    <FormGroup key={i} check>
                      <Label check>
                        <Input type="checkbox" defaultChecked={checkedHolder[h.AccountHolderId]} value={checkedHolder[h.AccountHolderId]} onClick={() => changeSignatureField('SignaturePeopleSelected', h.AccountHolderId)} />
                        {' '}
                        {h.AccountHolderName}
                      </Label>
                    </FormGroup>
                  );
                })}
              </React.Fragment>
            )}
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button
          onClick={toggle}
          style={{ marginLeft: 10 }}
        >
          Cancel

        </Button>
        <LaddaButton
          className="btn btn-ladda btn-primary"
          loading={saving}
          disabled={!signatureIsComplete(newSignature)}
          onClick={() => onSave(newSignature)}
          data-style={EXPAND_RIGHT}
        >
          {saving ? 'Saving' : 'Save'}

        </LaddaButton>
      </ModalFooter>
    </Modal>
  );
};

ModalSignature.propTypes = {
  signature: PropTypes.object.isRequired,
  holders: PropTypes.array.isRequired,
  newSetId: PropTypes.any.isRequired,
  onSave: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

export default ModalSignature;
